var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlugActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.358,
    height: 21.487,
    viewBox: "0 0 16.358 21.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plug",
    d: "M12.379,21.987a1.038,1.038,0,0,0,1.04-1.04V16.511a6.348,6.348,0,0,0,5.309-6.252V7.341h.79a1.04,1.04,0,0,0,0-2.079h-2.44V1.54A1.04,1.04,0,1,0,15,1.54V5.262H9.759V1.54a1.04,1.04,0,1,0-2.079,0V5.262H5.24a1.04,1.04,0,0,0,0,2.079h.79v2.918a6.348,6.348,0,0,0,5.309,6.252v4.436a1.038,1.038,0,0,0,1.04,1.04Z",
    transform: "translate(-4.2 -0.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugActive);
export default __webpack_public_path__ + "static/media/plugActive.16e712071cdb9bc6e8e619952bed0b55.svg";
export { ForwardRef as ReactComponent };